









import {
  defineComponent, ref, onBeforeMount
} from '@nuxtjs/composition-api';
import useRecentlyViewedProducts from "~/modules/catalog/product/composables/useRecentlyViewedProducts";
import ProductsSlider from '~/modules/catalog/category/components/views/ProductsSlider.vue';

export default defineComponent({
  components: {
    ProductsSlider,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { load, loading } = useRecentlyViewedProducts();
    const products = ref([]);

    onBeforeMount(async () => {
      products.value = await load() || [];
    });

    return {
      products,
      loading,
    };
  },
});
